import React, { useEffect, useState } from 'react';
import { useLocation as useRouteLocation, Link, useNavigate } from 'react-router-dom';
import usersAPI from '../../api/users';
import api from '../../utils/api';
import { useAuth } from '../../contexts/AuthContext';
import EditProfile from '../../components/userProfile/editProfile';
import { MdVerified } from "react-icons/md";
import { FaStar, FaFacebook, FaInstagram, FaTiktok, FaYoutube, FaGlobe, FaLinkedin, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import { FaXTwitter,FaArrowRight } from "react-icons/fa6";

export default function Profile() {
  const { user } = useAuth();
  const routeLocation = useRouteLocation();
  const navigate = useNavigate();
  const fromSearch = routeLocation.state?.fromSearch === true;
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [horseGroups, setHorseGroups] = useState({});
  const [activeTab, setActiveTab] = useState('forSale');
  const [breeds, setBreeds] = useState([]);


  {/*User Fetch*/}
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await usersAPI.getProfile();
        setProfile(res.data);
      } catch (err) {
        console.error('Failed to fetch user profile:', err);
        setError('Unable to load profile.');
      }
    };

    fetchUser();
  }, []);

  {/*User Horse Fetch*/}
  useEffect(() => {
    const fetchUserHorses = async () => {
      if (!profile?._id) return;

      try {
        const res = await api.get(`/horses/user/${profile._id}`);
        const horses = res.data;

        const grouped = {
          forSale: [],
          pending: [],
          sold: [],
          activeBid: [],
          bought: [],
        };

        horses.forEach((horse) => {
          const status = horse.status;
          const key = statusToKey(status);
          if (key && grouped[key]) {
            if (grouped[key].length < 3) {
              grouped[key].push(horse);
            }
          }
        });

        setHorseGroups(grouped);
      } catch (error) {
        console.error('❌ Failed to fetch horses by user:', error);
      }
    };

    fetchUserHorses();
  }, [profile]);

  {/*Breed Fetch*/}
  useEffect(() => {
    const fetchBreeds = async () => {
      try {
        const res = await api.get('/breeds');
        setBreeds(res.data);
      } catch (err) {
        console.error('Failed to fetch breeds:', err);
      }
    };
    fetchBreeds();
  }, []);

  const statusToKey = (status) => {
    switch (status) {
      case 'For Sale': return 'forSale';
      case 'Pending': return 'pending';
      case 'Sold': return 'sold';
      case 'Active Bid': return 'activeBid';
      case 'Bought': return 'bought';
      default: return '';
    }
  };

  const horseTabs = [
    { key: 'forSale', label: 'For Sale' },
    { key: 'pending', label: 'Pending' },
    { key: 'sold', label: 'Sold' },
    { key: 'activeBid', label: 'Active Bids' },
    { key: 'bought', label: 'Bought' },
  ];

  if (error) return <div className="text-red-600 p-4">{error}</div>;
  if (!profile) return <div className="text-gray-500 p-4">Loading...</div>;

  const {
    firstName,
    lastName,
    email,
    profileDescription,
    profileImage,
    address = {},
    isVerifiedSeller,
    rating,
    reviews = [],
    socialLinks = {},
    horses: rawHorses = {},
    joinedDate,
    sellerTier,
    completedTransactions,
    businessInfo,
    preferences,
    lastActive,
    followerCount,
  } = profile;

  const isOwnProfile = user?.firebaseUid === profile?.firebaseUid;

  const averageRating = reviews.length
  ? (reviews.reduce((sum, r) => sum + (r.rating || 0), 0) / reviews.length).toFixed(1)
  : null;

  return (
    <div className="max-w-4xl mx-auto p-4">

      {/*Return to Search Results*/}
      {fromSearch && (
        <Link to="/search" className="text-sm text-blue-600 hover:underline inline-block mb-4"> ← Back to Search Results </Link>
      )}

        {isOwnProfile && (
          <>
          {/*Edit Profile*/}
          <div className="flex flex-col place-content-evenly mb-4">
          <button onClick={() => setShowModal(true)} className="bg-primary text-white p-3 text-sm drop-shadow-md shadow-primary rounded-full text-center font-montserrat w-full mb-3"> Edit Profile </button>
          {/*Edit Profile*/}
          <button onClick={() => setShowModal(true)} className="bg-primary text-white p-3 text-sm drop-shadow-md shadow-primary rounded-full text-center font-montserrat w-full mb-3"> My Horses </button>
          {/*Edit Profile*/}
          <button onClick={() => setShowModal(true)} className="bg-primary text-white p-3 text-sm drop-shadow-md shadow-primary rounded-full text-center font-montserrat w-full mb-3"> My Bids </button>
          </div>
          </>
        )
      }
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 overflow-y-auto">
          <div className="min-h-screen flex items-center justify-center">
            <div className="bg-white w-full max-w-2xl mx-auto p-6 rounded shadow-md relative">
              <button onClick={() => setShowModal(false)} className="absolute top-2 right-2 text-gray-600 hover:text-gray-800">
                ✖
              </button>
              <EditProfile onClose={() => setShowModal(false)} onUpdate={setProfile} />
            </div>
          </div>
        </div>
      )}
     

      {/*Profile Heading*/}
      <section className="profile-heading">
        <div className="flex flex-col items-center gap-4 mb-6">
          <img src={profileImage || '/placeholder.jpg'} alt="Profile" className="w-48 h-48 rounded-full object-cover border"/> 
          <div className="font-montserrat">
            <h1 className="text-4xl text-primary font-medium font-cormorant">{firstName} {lastName}</h1>
            <div>
              <p className="text-sm text-gray-400 italic pb-2">{address.city || 'N/A'}, {address.state || 'N/A'}, {address.country || 'N/A'}</p>
              <div className="flex pb-2 justify-start gap-8">
                <p className="text-[12px] text-gray-400 italic">{followerCount|| ''} Followers</p>
                {averageRating && (
                <p className="text-[12px] text-gray-400 italic inline-flex items-center gap-1">
                <FaStar className="text-yellow-500 w-3 h-3" /> {averageRating}
              </p>
                )}
                <p className="text-[12px] text-gray-400 italic">{email}</p>
              </div>
            </div>

            {/*Description & Social*/}
            <div className="my-4">
              {/*Profile Description*/}
              <p className="text-md text-text pb-2">{profileDescription}</p>

              {/*Social Links*/}
              {Object.entries(socialLinks).some(([_, url]) => url) && (
              <div className="pt-2 pb-6">
                <div className="flex gap-4">
                  {Object.entries(socialLinks).map(([platform, url]) => {
                    if (!url) return null;

                    const iconMap = {
                      instagram: <FaInstagram />,
                      facebook: <FaFacebook />,
                      twitter: <FaXTwitter />,
                      linkedin: <FaLinkedin />,
                      youtube: <FaYoutube />,
                      tiktok: <FaTiktok />,
                      website: <FaGlobe />,
                    };

                    const icon = iconMap[platform.toLowerCase()] || '🔗';

                    return (
                      <a key={platform} href={url} target="_blank" rel="noopener noreferrer" className="text-md text-gray-600" title={platform}>{icon}</a>
                      );
                  })}
                </div>
              </div>
              )}
            </div>
            <div className="shadow p-2">
              <div className="flex place-content-around">
                <div className="flex flex-col gap-2 items-center">
                  <p className="text-sm text-text">Verified</p>
                  <span>{isVerifiedSeller ? <MdVerified className="text-green-600 inline w-8 h-8" /> : <MdVerified className="text-white-600 inline w-6 h-6" />}</span>
                </div>
                <div className="flex flex-col items-center gap-2">
                  <p className="text-sm text-text">Joined</p>
                  <span className="text-sm text-text">{joinedDate ? new Date(joinedDate).toLocaleDateString() : ''}</span>
                </div>
                <div className="flex flex-col items-center gap-2">
                  <p className="text-sm text-text">Last Active</p>
                  <span className="text-sm text-text">{lastActive ? new Date(lastActive).toLocaleDateString() : ''}</span>
                </div>
              </div>
              <div className="mt-3">
                {reviews.map((review, i) => {
                  const fullStars = Math.floor(review.rating);
                  const hasHalfStar = review.rating % 1 >= 0.5;
                  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
                    return (
                      <div key={i} className="flex flex-col p-4">
                        <div className="flex items-center gap-1 text-yellow-500 pb-2">
                          {[...Array(fullStars)].map((_, i) => <FaStar key={`full-${i}`} />)}
                          {hasHalfStar && <FaStarHalfAlt key="half" />}
                          {[...Array(emptyStars)].map((_, i) => <FaRegStar key={`empty-${i}`} />)}
                        </div>
                        <p className="text-sm text-gray-600 italic pb-2">{review.comment}</p>
                        <p className="text-sm text-gray-600 italic pb-1">{review.reviewer}</p>
                        <p className="text-xs text-gray-400">{new Date(review.createdAt).toLocaleDateString()}</p>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/*Horses*/}
      <section className="horse-list">
        <div className="mt-10 font-montserrat">
          <h2 className="text-2xl font-semibold text-text">Horses</h2>
          {/* Tab Headers */}
          <div className="overflow-x-auto whitespace-nowrap my-6 scroll-hide">
            <div className="flex gap-2">
              {horseTabs.map((tab) => (
                <button key={tab.key} onClick={() => setActiveTab(tab.key)} className={`px-4 py-2 font-mentserrat rounded-full text-[12px] transition-all duration-200 ${ activeTab === tab.key ? 'bg-primary text-white' : 'border-2 border-solid border-clay text-clay' }`} > {tab.label} </button>
              ))}
            </div>
          </div>

          {/* Tab Content */}
          <div className="mt-6">
            {(() => {
              const horsesInCategory = horseGroups?.[activeTab] || [];
              return (
                <div>
                  {horsesInCategory.length > 0 ? (
                    <ul className="flex flex-col gap-8 font-montserrat">
                      {horsesInCategory.map((horse) => (
                        <li key={horse._id} className="flex gap-6">
                          <img src={horse.horseInfo?.images?.[2] || '/placeholder.jpg'} alt={horse.horseInfo?.name || 'Unnamed Horse'} className="w-32 h-24 rounded object-cover border" />
                          <div className="flex flex-col justify-between">
                            <h4 className="text-md font-semibold text-text">{horse.horseInfo?.name || 'Unnamed Horse'}</h4>
                            <p className="text-sm text-text">{horse.horseInfo?.breed?.name || 'Unknown Breed'}</p>
                            <p className="text-sm text-text">{horse.horseInfo?.age || '?'} years old</p>
                            <Link to={`/horses/${horse._id}`} state={{ fromProfile: true }} className="text-[12px] text-primary hover:underline inline-flex items-center gap-1">More Info <span aria-hidden="true"><FaArrowRight/></span></Link>
                          </div>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-sm text-gray-500 italic">No horses in this category.</p>
                  )}
                </div>
              );
            })()}
          </div>
        </div>
      </section>
  
      {/*Transactional Profile*/}
      <section className="transaction-profile">
        <div className="mt-10 font-montserrat">
          <h2 className="text-2xl font-semibold mb-2">Transaction Preferences</h2>
          <p className="text-sm text-text mb-4">{preferences?.description}</p>
          <ul className="text-sm text-text shadow border-1.5 border-primary px-4 py-4">
            <li className="pb-2"><strong>Breeds:</strong> {Array.isArray(preferences?.breeds) && preferences.breeds.length > 0
            ? preferences.breeds.map(id => breeds.find(b => b._id === id)?.name).filter(Boolean).join(', ')
            : 'N/A'}
            </li>
            <li className="pb-2"><strong>Disciplines:</strong> {preferences?.disciplines?.join(', ') || 'N/A'}</li>
            <li className="pb-2"><strong>Price Range:</strong> ${preferences?.minPrice || '0'} to ${preferences?.maxPrice || 'N/A'}</li>
            <li className="pb-2"><strong>Age Range:</strong> {preferences?.age?.min || '0'} to {preferences?.age?.max || 'N/A'}</li>
            <li className="pb-2"><strong>Height Range (hands):</strong> {preferences?.height?.min || '0'} to {preferences?.height?.max || 'N/A'}</li>
            <li><strong>Temperament:</strong> {preferences?.temperament?.join(', ') || 'N/A'}</li>
          </ul>
        </div>
      </section>

      {/*Business Info*/}
      <section className="business-profile">
        <div className="mt-10 font-montserrat pb-4">
          <h2 className="text-2xl font-semibold mb-2">Business Information</h2>
          <div className="flex gap-3">
            <img src={businessInfo.logo || '/placeholder.jpg'} alt="Profile" className="w-24 h-24 rounded-full object-cover border"/>
            <div className="flex flex-col mt-1">
              <p>{businessInfo.name || 'N/A'}</p>
              <p className="text-sm text-gray-400 italic pb-4">{businessInfo.address.city || 'N/A'}, {businessInfo.address.state || 'N/A'}, {businessInfo.address.country || 'N/A'}</p>
              <div className="flex gap-2">
                {businessInfo?.social &&
                  Object.entries(businessInfo.social).map(([platform, url]) => {
                    if (!url) return null;
                      const iconMap = {
                        instagram: <FaInstagram />,
                        facebook: <FaFacebook />,
                        twitter: <FaXTwitter />,
                        linkedin: <FaLinkedin />,
                        youtube: <FaYoutube />,
                        tiktok: <FaTiktok />,
                        website: <FaGlobe />,
                      };
                      const icon = iconMap[platform.toLowerCase()] || '🔗';
                    return (
                        
                          <a key={platform} href={url} target="_blank" rel="noopener noreferrer" className="text-xl text-gray-600 hover:text-primary transition-colors" title={platform.charAt(0).toUpperCase() + platform.slice(1)}> {icon}</a>
                        );
                  })}
                </div>
            </div>
          </div>
        </div>
      </section>
      
      {!isOwnProfile && (
        <>
        {/*Follow*/}
        <button onClick={() => setShowModal(true)} className="bg-blue-600 text-white px-4 py-2 rounded mb-4"> Follow {firstName} </button>
        {/*Contact*/}
        <button onClick={() => setShowModal(true)} className="bg-blue-600 text-white px-4 py-2 rounded mb-4"> Contact </button>
        </>
        )
      }
    </div>
  );
}